import { ModulesEnum } from "@/store/actions/modulesEnum";

/**
 * Itens de menu que só devem aparecer quando o fornecedor da sessão tem o
 * módulo contratado. O cadastro do item continua no `item_menu` (server); aqui
 * apenas escondemos o subitem de quem não contratou o módulo.
 *
 * O gate é sempre `fornecedor.modulos[]` — nunca tag de fornecedor, claim
 * Keycloak ou canal de venda.
 */
export const MENU_LINKS_POR_MODULO = [
  {
    link: "/fornecedor/comercial/matriz-rfm",
    modulos: [ModulesEnum.LIFEGROWTH]
  },
  {
    link: "/fornecedor/configuracao/perfis-usuarios",
    modulos: [ModulesEnum.LIFEGROWTH]
  }
];

/**
 * @param {string} link link do item de menu
 * @param {function} moduloFornecedorAtivo getter `moduloFornecedorAtivo` da store
 */
export function linkLiberadoPorModulo(link, moduloFornecedorAtivo) {
  const regra = MENU_LINKS_POR_MODULO.find(item => item.link === link);
  if (!regra) return true;
  return moduloFornecedorAtivo(regra.modulos) === true;
}

/** Aplica o gate de módulo sobre a estrutura de grupos/subitens do menu. */
export function filtrarMenuPorModulo(itensMenu, moduloFornecedorAtivo) {
  return (itensMenu || []).reduce((itens, item) => {
    const subitens = (item.subitens || []).filter(subitem =>
      linkLiberadoPorModulo(subitem.link, moduloFornecedorAtivo)
    );

    if (!item.subitens) {
      if (linkLiberadoPorModulo(item.link, moduloFornecedorAtivo)) {
        itens.push(item);
      }
      return itens;
    }

    if (subitens.length > 0) {
      // O item representante do grupo precisa ser um dos subitens visíveis,
      // pois grupos com um único item usam `item.link` e `item.nome`.
      itens.push({ ...subitens[0], grupo: item.grupo, subitens });
    }

    return itens;
  }, []);
}
